<template>
  <div style="height:calc(100% - 90px); background-color: var(--color-0013); overflow-y:auto;  ">
    <div class="clsCls">
      <img style="position:absolute; width:120px; height:auto; top:20px; left:50%; transform:translateX(-50%);"
        src="@/assets/img/gxnzjl.png" />
    </div>

    <div v-if="state.prizedata.jiang"
      style="margin:20px; padding:20px; text-align:center; width:80%; border-radius:10px; background:#fff">

      <div v-if="state.jiangNum">
        <p style="font-size:14px; font-weight:600; margin-bottom:10px;">—— 您共中得奖金为<span
            style="color:var(--color-text6)">{{
      state.prizedata.allprice }}</span>元
          ——</p>
        <!-- <p style="color: var(--color-0015); padding:20px 50px;">大乐透、双色球、福彩3D、排列3、七星彩、排列5、快乐8</p> -->
        <template v-for="item in state.prizedata.jiang">
          <div v-if="item.count" style="font-size:16px; display:flex; justify-content: space-around; padding:10px 0px;">
            <p style="width:80px;">{{ item.title }}</p>
            <p style="width:80px;">{{ item.count + '注' }}</p>
            <p style="width:150px; color:var(--color-text7)">{{ item.price + '元' }}</p>
          </div>
        </template>
      </div>

      <div v-if="!state.jiangNum">
        <p style="font-size:14px; font-weight: 600;">—— 本次查验未中奖 ——</p>
        <p style="font-size:16px; color:var(--color-text6);">别灰心！下次再接再厉哦~</p>
      </div>

      <div style="display:flex; justify-content: space-around;">
        <van-button @click="goZS" style="width:100px; margin-right:10px;" type="primary" round>开奖走势</van-button>
        <van-button @click="goFA" style="width:100px; margin-right:10px;" type="primary" round>方案大厅</van-button>
        <van-button @click="scan" class="btn2Cls" style="width:100px;" type="primary" round>再次查奖</van-button>
      </div>

      <p style="text-align:left; line-height:16px;padding-top:10px;color:var(--color-9999)">
        本产品仅为辅助工具，对验奖准确性不做保证中将情况请以官方开奖公告及兑奖结果为准</p>
    </div>

    <div style="position: relative;">
      <div>
        <p style="text-align:center; color:var(--color-6666); font-size:14px;">{{ state.data.name + '第' + state.data.qiHao + '期开奖号码为' }}
        </p>

        <div v-if="state.prizedata.lottery_num"
          style="padding:5px 0px; margin: 0px 30px; display:flex; justify-content: center; flex-direction:row; flex-wrap: wrap;">
          <p class="btnrndred mybtnrnd"
            v-for="oo in getAwardNums(state.prizedata.lotteryId, state.prizedata.lottery_num)[0]">
            {{ oo }}
          </p>
          <p class="btnrndblue mybtnrnd"
            v-for="ooo in getAwardNums(state.prizedata.lotteryId, state.prizedata.lottery_num)[1]">
            {{ ooo }}
          </p>
        </div>

        <div style="overflow-y:auto; height:calc(100% - 70px)">
          <p style="text-align:center; padding:10px; color:var(--color-6666); font-size:14px;">{{ '—— 您查验的' + state.data.name + '-' +
      state.data.wanFa +
      ' 第' +
      state.data.qiHao + '期 ——' }}</p>

          <div style="position:relative" v-if="state.data.wanFa == '复式' || state.data.wanFa == '单式'"
            v-for="(ocrResList, index) in state.data.ocrResList">
            <div style="padding:5px 0; display:flex; align-items:center; justify-content:center">
              <div style="display:flex; flex-wrap: wrap; width:70%;">
                <p class="mybtnrnd unbtnrndred" :class="updPtCls(oov, state.prizedata, 'r', ooindex)"
                  v-for="(oov, ooindex) in ocrResList.res[0]">
                  {{ oov }}
                </p>
                <p class="mybtnrnd unbtnrndblue" :class="updPtCls(ooov, state.prizedata, 'b', oooindex)"
                  v-for="(ooov, oooindex) in ocrResList.res[2]">
                  {{ ooov }}
                </p>
              </div>
            </div>
            <p v-if="state.prizedata.iszj && state.prizedata.iszj[index] && state.prizedata.iszj[index] == 1"
              class="zjCls1">已中奖</p>
          </div>

          <div style="position:relative" v-if="state.data.wanFa == '胆拖'"
            v-for="(ocrResList, index) in state.data.ocrResList">
            <div
              style="margin-left:20px; padding:5px 0; display:flex; flex-direction:column; align-items:center; justify-content:center">
              <div v-if="ocrResList.res[0].length" style="display:flex; width:100%;">
                <p class="kkCls">红球胆</p>
                <div style="display:flex; flex-wrap: wrap; width:80%;">
                  <p class="mybtnrnd unbtnrndred" :class="updPtCls(oov, state.prizedata, 'r', ooindex)"
                    v-for="(oov, ooindex) in ocrResList.res[0]">
                    {{ oov }}
                  </p>
                </div>
              </div>

              <div v-if="ocrResList.res[1].length" style="display:flex; width:100%;">
                <p class="kkCls">红球拖</p>
                <div style="display:flex; flex-wrap: wrap; width:80%;">
                  <p class="mybtnrnd unbtnrndred" :class="updPtCls(oov, state.prizedata, 'r', ooindex)"
                    v-for="(oov, ooindex) in ocrResList.res[1]">
                    {{ oov }}
                  </p>
                </div>
              </div>

              <div v-if="ocrResList.res[2].length" style="display:flex; width:100%;">
                <p class="kkCls">蓝球胆</p>
                <div style="display:flex; flex-wrap: wrap; width:80%;">
                  <p class="mybtnrnd unbtnrndblue" :class="updPtCls(ooov, state.prizedata, 'b', oooindex)"
                    v-for="(ooov, oooindex) in ocrResList.res[2]">
                    {{ ooov }}
                  </p>
                </div>
              </div>

              <div v-if="ocrResList.res[3].length" style="display:flex; width:100%;">
                <p class="kkCls">蓝球拖</p>
                <div style="display:flex; flex-wrap: wrap; width:80%;">
                  <p class="mybtnrnd unbtnrndblue" :class="updPtCls(ooov, state.prizedata, 'b', oooindex)"
                    v-for="(ooov, oooindex) in ocrResList.res[3]">
                    {{ ooov }}
                  </p>
                </div>
              </div>
            </div>
          </div>



        </div>

      </div>
    </div>

    <!-- <div style="position:absolute; bottom:0px; ">
      <div style="width:100%; display:flex; justify-content: space-around;">
        <van-button @click="back" class="btn1Cls" style="width:150px;" type="primary" round>返回</van-button>
        <van-button @click="scan" class="btn2Cls" style="width:150px;" type="primary" round>再次查奖</van-button>
      </div>

      <p style="padding:10px 40px;color:var(--color-9999)">
        本产品仅为辅助工具，对验奖准确性不做保证中将情况请以官方开奖公告及兑奖结果为准</p>
    </div> -->
  </div>
</template>
<script setup>
import { ref, reactive, computed } from 'vue'

import { updPtCls, deepClone, getAwardNums } from '@/LottHelper'


import { Lottery } from "@/StaticName";

import axios from 'axios'

const props = defineProps({
  data: { type: Object, default: {} },
  lotId: { type: Number, default: 0 },
  token: { type: String, default: '' },
  line: { type: String, default: '' },
  back: { type: Function, default: null },
})

const state = reactive({
  data: props.data,
  prizedata: {},

  top: 140,
  jiangNum: 0,
})

const back = () => {
  props.back(0);
}

const scan = () => {
  props.back(1);
}

const goZS = () => {
  window.parent.postMessage({ text: "zs", lotId: props.lotId });
}

const goFA = () => {
  window.parent.postMessage({ text: "fa", lotId: props.lotId });
}

const calJj = d => {

  let config = {
    headers: {
      'csbd-Token': props.token,
    },
    timeout: 7000,
    CTM: true
  }

  let content = {
    data: d.data,
    periods_num: Number(d.periods_num),
    lotteryId: d.lotteryId,
    playcode: Number(d.playcode),
    type: Number(d.type),
    name: d.name
  }

  // let url = props.line + '/api/user/xzjz/pdzj_smkj';
  let url = 'http://119.45.153.45:8099/api/user/xzjzs/pdzj_smkj'; //展示接口
  let params = {
    url: url,
    content: content,
    headers: [{
      'key': 'csbd-Token',
      'value': props.token
    }, {
      'key': 'Content-Type',
      'value': 'application/json'
    }]
  }

  // state.prizedata = {
  //   "allcount": 4,
  //   "allprice": 76078,
  //   "iszj": [
  //     0,
  //     0,
  //     1,
  //     0,
  //     0,
  //     0,
  //     0,
  //     1,
  //     0,
  //     0
  //   ],
  //   "jiang": {
  //     "1": {
  //       "count": 0,
  //       "mingci": 1,
  //       "price": "0.0",
  //       "title": "一等奖"
  //     },
  //     "2": {
  //       "count": 1,
  //       "mingci": 2,
  //       "price": "76073.0",
  //       "title": "二等奖"
  //     },
  //     "3": {
  //       "count": 0,
  //       "mingci": 3,
  //       "price": "0.0",
  //       "title": "三等奖"
  //     },
  //     "4": {
  //       "count": 0,
  //       "mingci": 4,
  //       "price": "0.0",
  //       "title": "四等奖"
  //     },
  //     "5": {
  //       "count": 0,
  //       "mingci": 5,
  //       "price": "0.0",
  //       "title": "五等奖"
  //     },
  //     "6": {
  //       "count": 0,
  //       "mingci": 6,
  //       "price": "0.0",
  //       "title": "六等奖"
  //     },
  //     "7": {
  //       "count": 0,
  //       "mingci": 7,
  //       "price": "0.0",
  //       "title": "七等奖"
  //     },
  //     "8": {
  //       "count": 0,
  //       "mingci": 8,
  //       "price": "0.0",
  //       "title": "八等奖"
  //     },
  //     "9": {
  //       "count": 1,
  //       "mingci": 9,
  //       "price": "5.0",
  //       "title": "九等奖"
  //     }
  //   },
  //   "allzjcount": 2,
  //   "periods_num": "23111",
  //   "lottery_num": "03,12,15,28,35,02,12"
  // };
  // state.prizedata['lotteryId'] = d.lotteryId;

  // let jj = state.prizedata.jiang;

  // if (jj) {
  //   for (let i in jj) {
  //     let jjj = jj[i];
  //     if (jjj.count) state.jiangNum++;
  //   }
  // }

  axios.post(window.url1 + 'api/User/HttpJump', params, config).then((res) => {
    if (res.data.code == 1) {
      state.prizedata = res.data.data;
      state.prizedata['lotteryId'] = d.lotteryId;

      let jj = state.prizedata.jiang;

      if (jj) {
        for (let i in jj) {
          let jjj = jj[i];
          if (jjj.count) state.jiangNum++;
        }
      }
    }
  }).catch((e) => {
  })
}

const dynamicStyle = computed(() => ({
  width: '100%',
  textAlign: 'center',
  position: 'absolute',
  top: (state.top + state.jiangNum * 36) + 'px',
  height: "calc(100% - " + (state.top + state.jiangNum * 36 + 92) + "px)",
}))

const init = () => {

  let lottery = deepClone(Lottery);
  lottery = Object.values(lottery);

  let lott = lottery.find(item => item.name == state.data.name);
  console.log('state.ocrResList:', state.data.ocrResList);


  let s = [];
  let playcode = 1;

  let wanfa = state.data.wanFa;

  //s 多层数组 1层 多组 2层红球红拖篮球蓝拖 3层位 百十个 4层 号码

  let list = deepClone(state.data.ocrResList);

  for (let i in list) {
    let ocrList = list[i];

    for (let j in ocrList.res) {
      let res = ocrList.res[j];

      if (ocrList.res[j].length) {
        ocrList.res[j] = [res];
      }
    }

    s.push(ocrList.res);
  }

  if (lott.id == Lottery.kl8.id) {
    playcode = wanfa.replace("选一", 1)
      .replace("选二", 2)
      .replace("选三", 3)
      .replace("选四", 4)
      .replace("选五", 5)
      .replace("选六", 6)
      .replace("选七", 7)
      .replace("选八", 8)
      .replace("选九", 9)
      .replace("选十", 10)
  } else {
    playcode = wanfa.replace("单式", 1)
      .replace("复式", 1)
      .replace("组三", 2)
      .replace("胆拖", 2)
      .replace("组六", 3)
  }

  let d = {};
  d.lotteryId = lott.id;
  d.data = s;
  d.name = state.data.wanFa;
  d.type = wanfa.replace("单式", 0)
    .replace("复式", 1)
    .replace("胆拖", 2);
  d.periods_num = state.data.qiHao;
  d.playcode = playcode;

  calJj(d);
}

init();

</script>
<style lang="less" scoped>
.mybtnrnd {
  width: 30px !important;
  height: 30px !important;
  line-height: 30px !important;
  margin: 3px;
  border-radius: 15px;
  font-size: 16px;
}

.camera-container {
  width: 100%;
  /* 设置容器大小 */
  height: 100%;
  background-color: #000;
  text-align: center;

  .content {
    position: relative;
    width: calc(100% - 60px);
    height: calc(100% - 250px);
    display: inline-block;

    .kk {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
    }
  }

  >p {
    font-size: 12px;
    color: #fff;
    margin: 0px;
    padding-left: 10px;
    padding-top: 10px;
    text-align: left;
    margin-bottom: 10px;
  }

  .btn {
    width: 60px;
    height: 60px;
    background-color: #fff;
    display: inline-block;
    margin-top: 40px;
    border-radius: 30px;
  }
}

.zjCls1 {
  color: #fff;
  background: var(--color-0015);
  padding: 2px 5px;
  border-radius: 5px;
  margin-right: 5px;
  width: 30px;
  font-size: 10px;

  position: absolute;
  top: 15px;
  right: 15px;
}

.clsCls {
  background-image: url(@/assets/img/bg_1.png);
  width: 100%;
  height: 150px;
  background-size: cover;
  background-position: center;
  position: relative;
}

.kkCls {
  line-height: 36px;
  padding: 0 10px;
  font-size: 14px;
  width: 100px;
}
</style>